import { RouteConfig } from 'vue-router'
import { GlobalConfigRouteMetaEnum } from 'kuaidong-model'
const LayoutEmpty = () => import('../views/LayoutEmpty.vue')

const OnlineGameList = () => import('../views/CompetitionOnlineGameList.vue')
const OnlineGameDetail = () => import('../views/CompetitionOnlineGameDetail.vue')
const OnlineGameStatDetail = () => import('../views/CompetitionManagementDetailsStats.vue')
const OnlienGameAwards = () => import('../views/CompetitionOnlineGameAwards.vue')
export const onlineGameListRoute: RouteConfig = {
  path: 'online-game-list',
  name: 'competition_online_game_list',
  component: OnlineGameList,
  meta: {
    title: '在线运动会',
    showMenu: true,
  },
}

export const onlineGameDetailRoute: RouteConfig = {
  path: 'online-game-detail',
  name: 'competition_online_game_detail',
  component: OnlineGameDetail,
  props: (route) => ({ ...route.query, ...route.params }),

  meta: {
    title: '在线运动会详情',
    [GlobalConfigRouteMetaEnum.All]: true,
  },
}

export const OnlineGameStatDetailRoute: RouteConfig = {
  path: 'online-game-stat-detail',
  name: 'competition_online_game_stat_detail',
  component: OnlineGameStatDetail,
  props: (route) => ({ ...route.query, ...route.params }),

  meta: {
    title: '在线运动会统计详情',
  },
}

export const OnlineGameAwardsRoute: RouteConfig = {
  path: 'online-game-awards',
  name: 'competition_online_game_awards',
  component: OnlienGameAwards,
  props: (route) => ({
    drillInfo: JSON.parse(route.query.drillInfo as string),
    awardsStatus: JSON.parse(route.query.awardsStatus as string),
    matchDetail: JSON.parse(route.query.matchDetail as string),
    ...route.query,
    ...route.params,
  }),

  meta: {
    title: '在线运动会',
  },
}

export default [
  {
    path: '/competition-online-game',
    name: 'competition_online_game',
    component: LayoutEmpty,
    redirect: onlineGameListRoute.name,
    children: [onlineGameListRoute, onlineGameDetailRoute, OnlineGameStatDetailRoute, OnlineGameAwardsRoute],
  },
]
